/*
 * @Author: Json Chen
 * @Date: 2021-07-28 16:37:04
 * @LastEditTime: 2021-08-12 09:30:31
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelLocalisation/Components/AreaCodeModalForm.tsx
 */

import { Filter } from '@/src/components';
import { SizeFittingTable } from '@/src/components/Antd';
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import React, { useMemo, useState } from 'react';

import styles from '../style.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const AreaCodeModalForm = ({
  onCancel,
  onModalConfirm,
  existList,
  areaCodes,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [confirmDisable, setConfirmDisable] = useState<boolean>(false);
  const [_searchValue, _setSearchValue] = useState<string>('');
  const [searchValue, setSearchValue] = useState<string>('');
  const [checkedList, setCheckedList] = useState(() =>
    existList.reduce((pre, item) => {
      const i = areaCodes.find((a) => a.uuid === item.areaCodeInfo?.uuid);
      if (i) {
        return [...pre, i];
      }
      return pre;
    }, []),
  );

  const list = useMemo(() => {
    const v = searchValue.toLowerCase();
    return areaCodes
      .map((item) => {
        const show = v
          ? item.areaCode.toLowerCase().includes(v) ||
            item.name.toLowerCase().includes(v) ||
            item.code.toLowerCase().includes(v)
          : true;

        return {
          ...item,
          _show: show,
        };
      })
      .sort((a, b) => {
        if (a && b && a.name && b.name) {
          return a.name[0].charCodeAt() - b.name[0].charCodeAt();
        }
        return 0;
      });
  }, [areaCodes, searchValue]);

  const onSearchChange = (v) => {
    _setSearchValue(v);
  };

  const onOk = () => {
    onModalConfirm(checkedList);
    _onCancel();
  };

  const _onCancel = () => {
    setConfirmDisable(true);
    onCancel();
  };

  const rowSelection = {
    selectedRowKeys: checkedList.map((item) => item.uuid),
    onChange: (selectedList) => {
      setCheckedList(
        areaCodes.filter((item) => selectedList.includes(item.uuid)),
      );
    },
  };

  const calcRowClassName = (record) => {
    return record._show ? styles.show : styles.hide;
  };
  const columns = [
    {
      title: getI18n('salesChannelLocalisation.index.areaCode'),
      dataIndex: 'code',
      default: true,
      minWidth: 192,
      childGenerate: (text, record) => {
        return (
          <div>
            {record.name} (+{record.areaCode})
          </div>
        );
      },
    },
  ];

  return (
    <React.Fragment>
      <Filter
        className={styles.modalSearch}
        searchClassName={styles.modalSearchInput}
        searchValue={_searchValue}
        searchOnchange={onSearchChange}
        pressEnter={(e) => setSearchValue(e.target.value)}
        onSearch={setSearchValue}
      />

      <SizeFittingTable
        id='AreaCodeModalForm'
        className={styles.modalTable}
        rowClassName={calcRowClassName}
        rowKey='uuid'
        columns={columns}
        dataSource={list}
        rowSelection={rowSelection}
        pagination={false}
      />
      <ModalFooter
        okText={getI18n('general.confirm')}
        onCancel={_onCancel}
        onOk={onOk}
        hideOkButton={confirmDisable}
      />
    </React.Fragment>
  );
};

export default AreaCodeModalForm;
